import React from "react";
import EmptyState from "./EmptyState";
import LoadingSpinner from "./LoadingSpinner";
import { colors, radii, spacing } from "./theme";

export default function DataTable({
  columns = [],
  data = [],
  loading = false,
  emptyTitle = "No records found",
  emptyMessage = "There is no data to display yet.",
  onRowClick,
  getRowKey = (row, index) => row._id || row.id || index
}) {
  if (loading) {
    return <LoadingSpinner label="Loading data..." />;
  }

  if (!data.length) {
    return (
      <EmptyState
        icon="📄"
        title={emptyTitle}
        message={emptyMessage}
      />
    );
  }

  return (
    <div style={tableWrapperStyle}>
      <table style={tableStyle}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key} style={thStyle}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.map((row, index) => (
            <tr
              key={getRowKey(row, index)}
              onClick={() => onRowClick?.(row)}
              style={{
                ...trStyle,
                cursor: onRowClick ? "pointer" : "default"
              }}
            >
              {columns.map((column) => (
                <td key={column.key} style={tdStyle}>
                  {column.render
                    ? column.render(row)
                    : row[column.key] || "-"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const tableWrapperStyle = {
  width: "100%",
  overflowX: "auto",
  border: `1px solid ${colors.border}`,
  borderRadius: radii.lg,
  background: colors.surface
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  minWidth: 900
};

const thStyle = {
  textAlign: "left",
  padding: `${spacing.md}px ${spacing.lg}px`,
  borderBottom: `2px solid ${colors.border}`,
  background: colors.surfaceMuted,
  color: colors.textMuted,
  fontSize: 13,
  fontWeight: 800
};

const tdStyle = {
  padding: `${spacing.md}px ${spacing.lg}px`,
  borderBottom: `1px solid ${colors.border}`,
  color: colors.text,
  fontSize: 14
};

const trStyle = {
  transition: "background .15s ease"
};